import { AssetKeys } from '@components/EntityDrawers/drawers/Assessment/keys';
import useBusinessAttributesOptions from '@components/EntityDrawers/hooks/useBusinessAttributesOptions';
import ControlledAutocomplete from '@components/Inputs/controllers/ControlledAutocomplete';
import { useProject } from '@context/Project/ProjectProvider';
import { useEffect, useState } from 'react';

const BusinessAttributesInput = () => {
  const [isOpened, setIsOpened] = useState(false);
  const { options, isLoading } = useBusinessAttributesOptions(isOpened);

  const { viewOnly } = useProject();

  return (
    <ControlledAutocomplete
      name={AssetKeys.BusinessAttributes}
      label="Business attributes"
      placeholder="Select business attributes"
      options={options}
      loading={isLoading}
      readOnly={viewOnly}
      multiple
      onOpen={() => setIsOpened(true)}
    />
  );
};

export default BusinessAttributesInput;
